/**
 *  @description A utility class for cameras. Used to create, focus, translate cameras etc.
 */

// @ts-ignore
import TWEEN from '@tweenjs/tween.js';
import * as THREE from 'three';
import { PerspectiveCamera } from 'three';

export class CameraUtility {
  /**
   * @description Move the camera to focus on a object
   */
  focusOnObject(camera: THREE.Camera, object: THREE.Object3D, offset = 1.0) {
    // get bounding box of object - this will be used to setup controls and camera
    const boundingBox = new THREE.Box3();
    boundingBox.setFromObject(object);

    this.focusOnBox(camera, boundingBox, offset);
  }

  /**
   * @description Move the camera to focus on a box
   */
  focusOnBox(camera: THREE.Camera, boundingBox: THREE.Box3, offset = 1.0) {
    offset = offset || 1.2;

    const center: THREE.Vector3 = new THREE.Vector3();
    const size: THREE.Vector3 = new THREE.Vector3();
    boundingBox.getCenter(center);
    boundingBox.getSize(size);

    center.setZ(0);

    // get the max side of the bounding box (fits to width OR height as needed )
    const maxDim = size.length();
    const fov = (camera as PerspectiveCamera).fov * (Math.PI / 180);
    let cameraZ = Math.abs((maxDim / 4) * Math.tan(fov * 2));
    cameraZ *= offset; // zoom out a little so that objects don't fill the screen

    const newPosition = center.sub(
      camera.getWorldDirection(new THREE.Vector3()).normalize().multiplyScalar(cameraZ),
    );

    new TWEEN.Tween(camera.position)
      .to(newPosition, 1000)
      .onUpdate(function () {
        camera.position.set(
          // @ts-ignore
          this._object.x as number,
          // @ts-ignore
          this._object.y as number,
          // @ts-ignore
          this._object.z as number,
        );
      })
      .easing(TWEEN.Easing.Quadratic.Out)
      .start();
  }
}
